import { render, staticRenderFns } from "./IdCampaign.vue?vue&type=template&id=6c01f1cf&"
import script from "./IdCampaign.vue?vue&type=script&lang=js&"
export * from "./IdCampaign.vue?vue&type=script&lang=js&"
import style0 from "./IdCampaign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports